<template>
  <el-card
    class="expert-contact-card"
    :body-style="{ height: '100%', 'background-color': 'var(--nxt-color-lightest-blue)'}">
    <div class="expert-contact-card__body">
      <div>
        <img
          class="expert-contact-card__body__image"
          :src="image"
          @error="setFallback" />
      </div>
      <p
        class="expert-contact-card__body__text to-upper-case"
        v-html="$t('home.descriptifsCards.contactExpert', { expert: expertName })">
      </p>
      <div class="expert-contact-card__body__button">
        <router-link :to="{ name: 'contact' }">
          <el-button
            type="primary">
            {{ $t('home.descriptifsCards.contact') }}
          </el-button>
        </router-link>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'pinia';
import { useDemandStore } from '@/stores';
import blankUser from '@/assets/img/blank-user.png';

export default {
  name: 'expertContactCard',
  data() {
    return {
      fallback: false,
    };
  },
  computed: {
    ...mapState(useDemandStore, ['demand']),
    expertName() {
      if (this.expert) {
        return this.expert.first_name;
      }
      return this.$t('home.descriptifsCards.noExpert');
    },
    expert() {
      if (this.demand.assigned_user) {
        return this.demand.assigned_user;
      }
      if (this.demand.meeting && this.demand.meeting.expert) {
        return this.demand.meeting.expert;
      }
      return null;
    },
    image() {
      if (!this.expert) {
        return blankUser;
      }
      return this.fallback
        ? blankUser
        : `${import.meta.env.VITE_APP_PUBLIC_ASSETS_URL}images/users/${this.expert.id}.png`;
    },
  },
  methods: {
    setFallback() {
      this.fallback = true;
    },
  },
};
</script>

<style scoped lang="scss">
.expert-contact-card {
  margin-bottom: 20px;
  border-radius: 0;
  border: none;
  @include breakpoint(tablet) {
    border-radius: 4px;
    margin: 0;
  }
  &__body {
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: 0;
    font-size: 18px;
    height: 100%;
    &__image {
      border-radius: 50%;
      width: 100px;
    }
    &__text {
      margin: 10px 0;
      font-size: 16px;
      flex: 1 1;
    }
  }
}
</style>
